var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.4H4.44444V12.6H6.66667V10.4ZM11.1111 10.4H8.88889V12.6H11.1111V10.4ZM15.5556 10.4H13.3333V12.6H15.5556V10.4ZM17.7778 2.7H16.6667V1.61111C16.6667 0.997461 16.1692 0.5 15.5556 0.5C14.9419 0.5 14.4444 0.997461 14.4444 1.61111V2.7H5.55556V1.61111C5.55556 0.997461 5.05809 0.5 4.44444 0.5C3.8308 0.5 3.33333 0.997461 3.33333 1.61111V2.7H2.22222C0.988889 2.7 0.0111111 3.69 0.0111111 4.9L0 20.3C0 21.51 0.988889 22.5 2.22222 22.5H17.7778C19 22.5 20 21.51 20 20.3V4.9C20 3.69 19 2.7 17.7778 2.7ZM17.7778 20.3H2.22222V8.2H17.7778V20.3Z",
    fill: "#D52B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.98e71884d8213ae0138f5d5caf902b95.svg";
export { ForwardRef as ReactComponent };